module.exports = __webpack_public_path__ + "img/nickname.93a6d6f0.png";